import { render, staticRenderFns } from "./SystemErrorPage.vue?vue&type=template&id=b8583008&scoped=true&"
import script from "./SystemErrorPage.vue?vue&type=script&lang=js&"
export * from "./SystemErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8583008",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8583008')) {
      api.createRecord('b8583008', component.options)
    } else {
      api.reload('b8583008', component.options)
    }
    module.hot.accept("./SystemErrorPage.vue?vue&type=template&id=b8583008&scoped=true&", function () {
      api.rerender('b8583008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/SystemErrorPage.vue"
export default component.exports